var exports = {
  "X": "LabelTokenDecorator__aLw2mf",
};

module.exports = exports;
